import axios from "axios";
import { getAccessToken } from "Helpers/session";
import { isEmpty, omitBy, isNil } from "lodash";
import errorHandler from "Utils/error-handler";
import normalize from "Utils/normalizer";

export const updateProfile = async (data: any) => {
  // check API url
  const url = `${process.env.API_URL}/${process.env.API_VER}/profile/update`;
  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: "POST",
      url: url,
      data: { profile: normalize.model.profile(data) },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    const responseData = response.data;

    return !isEmpty(responseData.profile) ? responseData.profile : {};
  } catch (err) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await updateProfile(data);
      const callbackResponse = await errorHandler.response(error, { callback });
      if (callbackResponse?._id) return callbackResponse;
      const { value, code, message, stack } = callbackResponse;
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const fetchProfile = async (filters: any) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}/profile/fetch`;
  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: "POST",
      url: url,
      data: omitBy(filters, isNil),
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    const responseData = response.data;

    return !isEmpty(responseData) ? normalize.response.employee(responseData) : {};
  } catch (err) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchProfile(filters);
      const callbackResponse = await errorHandler.response(error, { callback });
      if (callbackResponse?._id) return callbackResponse;
      const { value, code, message, stack } = callbackResponse;
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};
